import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { Html, useScroll } from '@react-three/drei'
import EffectOrchestreur from './EffectOchestreur'
import { ActsProvider } from './ActsProvider'
import { RefsProvider } from './RefsProvider'

import ActeOne from './actes/One/ActeOne'
import ActeTwo from './actes/Two/ActeTwo'
import ActeThree from './actes/Three/ActeThree'
import ActeFour from './actes/Four/ActeFour'
import AudioComponent from './audio/AudioComponent'


export default function Experience() {
    const scroll = useScroll()
    const progress = useRef()
    useFrame(() => {
        progress.current = scroll.offset
    })
    return <>
        <>
            
                <AudioComponent />
                <ActsProvider>
                    <RefsProvider>
                        <ActeOne progress={progress} />
                        <ActeTwo progress={progress} />
                        <ActeThree progress={progress} />
                        <ActeFour progress={progress} />
                        <EffectOrchestreur progress={progress} />
                    </RefsProvider>
                </ActsProvider>
            
        </>
    </>
} 